import { ErrorMessage, Field, FieldArray } from "formik";
import { Button, Card } from "react-bootstrap";
import { FaPlusCircle, FaTrash } from "react-icons/fa";
import allowNumbersOnly, { allowAlphabetAndSpacesOnly, handlePaste } from "../CommonUtils/CommonValidations";
const MembersTable = ({ title, name, formik, disabled }) => {
  // const roleOptions = ["Chairman", "Secretary", "Treasurer", "Member", "Board Member"];
  const roleOptions = ["Chairman", "Treasurer", "Member", "Board Member"];

  return (
    <FieldArray name={name}>
      {({ push, remove }) => (
        <table className="table table-bordered mt-2 ">
          <thead className="table-primary">
            <tr>
              <th>S.No</th>
              <th>Name</th>
              <th>Address</th>
              <th>Contact No.</th>
              <th>Role</th>
              <th>Responsibilities</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {formik.values[name].map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>
                  <Field name={`${name}.${index}.name`} type="text" className="form-control" placeholder="Name" disabled={disabled} onKeyPress={allowAlphabetAndSpacesOnly} maxLength={200} />
                  <ErrorMessage name={`${name}.${index}.name`} component="div" className="text-danger" />
                </td>

                <td>
                  <Field name={`${name}.${index}.address`} type="text" className="form-control" placeholder="Address" disabled={disabled} />
                  <ErrorMessage name={`${name}.${index}.address`} component="div" className="text-danger" />
                </td>

                <td>
                  <Field
                    name={`${name}.${index}.mobile`}
                    className="form-control"
                    type="text"
                    placeholder="Mobile Number"
                    disabled={disabled}
                    maxLength={10}
                    onKeyPress={allowNumbersOnly}
                    onPaste={handlePaste}
                  />
                  <ErrorMessage name={`${name}.${index}.mobile`} component="div" className="text-danger" />
                </td>

                <td>
                  <Field as="select" name={`${name}.${index}.role`} className="select-input" disabled={disabled}>
                    <option value="">Select Role</option>

                    {roleOptions.map((role) => (
                      <option key={role} value={role}>
                        {role}
                      </option>
                    ))}
                  </Field>

                  <ErrorMessage name={`${name}.${index}.role`} component="div" className="text-danger" />
                </td>

                <td>
                  <Field name={`${name}.${index}.responsibilities`} className="form-control" type="text" placeholder="Responsibilities" onKeyPress={allowAlphabetAndSpacesOnly} disabled={disabled} />
                  <ErrorMessage name={`${name}.${index}.responsibilities`} component="div" className="text-danger" />
                </td>
                <td className="d-flex gap-2">

                  {formik.values[name].length > 1 && (
                    <button type="button" className="btn btn-danger btn-sm" onClick={() => remove(index)} disabled={disabled}>
                      <FaTrash />
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot className="faculty-table-footer">
            <tr>
              <td colSpan="9" className="text-end">
                <Button
                  variant="success"
                  size="sm"
                  disabled={disabled}
                  onClick={() => {
                    // This push should be for a different array - maybe you have a separate faculty array?
                    // If you want to add to courses, use arrayHelpers.push instead
                    push({
                      name: "",
                      address: "",
                      mobile: "",
                      role: "",
                      responsibilities: "",
                    });
                  }}
                >
                  <FaPlusCircle className="me-2" />
                  Add
                </Button>
              </td>
            </tr>
          </tfoot>
        </table>
      )}
    </FieldArray>
  );
};
export default MembersTable;
